export default __webpack_public_path__ + "static/media/naturevshumanGame.1d71038d.png";